export default __webpack_public_path__ + "static/1180-c11e84f66ed30b6ead047af9f066fd45.gif";